'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _normalizr = require('normalizr');

var activityService = new _normalizr.Schema('activity_services');
var departureService = new _normalizr.Schema('departure_services');
// SHI-1076: JACKET_SIZE now PATCHes through departure_services (alongside boots_sizes).
// merchandise_services is kept registered for the legacy path only; it's no longer used
// by the Personal Information form. TODO: remove once the legacy path is fully retired.
var merchandiseService = new _normalizr.Schema('merchandise_services');

var serviceSchema = {
    // must be underscored and not in camel case to match what the API sends back
    activity_services: activityService,
    departure_services: departureService,
    merchandise_services: merchandiseService
};

exports.default = serviceSchema;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/api/schemas/serviceSchema.js
// module id = 1293
// module chunks = 0